import { Draft } from '@reduxjs/toolkit';

import { IImageData } from '../../index';

function uploadFailure(draft: Draft<IImageData>) {
  draft.upload.config.isLoading = false;
}

export default uploadFailure;
